var getRelFromTarget = (target) => {
    if (!target) {
        return undefined;
    }
    return ['_self', '_blank', '_parent', '_top'].includes(target)
        ? 'noopener noreferrer'
        : undefined;
};

export { getRelFromTarget as default };
//# sourceMappingURL=getRelFromTarget.js.map
